import React from 'react';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import AdminAuthFlow from 'hoc/AdminAuthFlow';

const OktaReceive = () => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={[]} />}
        title={<TitleContainer title="Please wait, verifying token..." admin hideDatePicker />}>
    </AdminTemplate>
);

export default AdminAuthFlow({ oktaReceive: true })(OktaReceive);



// WEBPACK FOOTER //
// ./src/components/pages/admin/OktaReceiver.js